
import hubei from './hubeiproject/index'

export default {
  hubei
};
